import { render } from "./SubmissionBuilder.vue?vue&type=template&id=7f1f56de&scoped=true"
import script from "./SubmissionBuilder.vue?vue&type=script&lang=js"
export * from "./SubmissionBuilder.vue?vue&type=script&lang=js"

import "./SubmissionBuilder.vue?vue&type=style&index=0&id=7f1f56de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1f56de"]])

export default __exports__